module.exports = __webpack_public_path__ + "img/Misi2-2-1Ilustrasi Feeling.a4334c6c.png";